<template>
  <div>
    <h2>Globale Komponentenhilfe</h2>
    <p>Ein Eintrag je technischem Komponententyp. Änderungen gelten für alle Customizing-Formulare.</p>
    <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
    <div ref="renderer"></div>
  </div>
</template>
<script>
import { Formio } from 'formiojs';
import ApiEditGridComponent from '@/components/formio/ApiEditGridComponent.js';
export default {
  data: () => ({ renderer: null, error: '' }),
  async mounted() {
    Formio.Components.addComponent('apiEditGrid', ApiEditGridComponent);
    try {
      const renderer = await Formio.createForm(this.$refs.renderer, {
        display: 'form', components: [{
          type: 'apiEditGrid', key: 'componentHelp', label: 'Komponentenhilfe', input: true,
          allowAdd: true, allowEdit: true, allowDelete: true,
          api: {
            loadEndpoint: '/api/component-help/manage', resultPath: '',
            createEndpoint: '/api/component-help', updateEndpoint: '/api/component-help/{componentHelpId}',
            deleteEndpoint: '/api/component-help/{componentHelpId}', idField: 'componentHelpId',
            autoLoad: true, reloadAfterSave: true, reloadAfterDelete: true
          },
          components: [
            { type: 'textfield', key: 'componentType', label: 'Technischer Komponententyp', input: true, validate: { required: true, maxLength: 128 }, description: 'Zum Beispiel editgrid oder apiEditGrid.' },
            { type: 'textarea', key: 'explanationText', label: 'Allgemeine Erklärung', input: true, validate: { maxLength: 4000 } },
            { type: 'textfield', key: 'documentationUrl', label: 'Dokumentations-URL (HTTP/HTTPS)', input: true, validate: { maxLength: 2048 } },
            { type: 'checkbox', key: 'isActive', label: 'Aktiv', input: true, defaultValue: true },
            { type: 'hidden', key: 'componentHelpId', input: true },
            { type: 'hidden', key: 'rowVersion', input: true }
          ]
        }]
      }, { language: 'de' });
      if (this._isDestroyed) renderer.destroy(); else this.renderer = renderer;
    } catch (_) { this.error = 'Die Komponentenhilfe konnte nicht geladen werden.'; }
  },
  beforeDestroy() { if (this.renderer) this.renderer.destroy(); }
};
</script>
